var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleCheckmarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8198 27.8198C26.0017 29.6379 23.6853 30.876 21.1636 31.3776C18.6418 31.8793 16.028 31.6218 13.6525 30.6379C11.2771 29.6539 9.24677 27.9877 7.81831 25.8499C6.38985 23.712 5.62742 21.1986 5.62742 18.6274C5.62742 16.0563 6.38985 13.5429 7.81831 11.405C9.24677 9.26719 11.2771 7.60095 13.6525 6.61701C16.028 5.63307 18.6418 5.37563 21.1636 5.87723C23.6853 6.37884 26.0017 7.61697 27.8198 9.43505C30.2578 11.873 31.6274 15.1796 31.6274 18.6274C31.6274 22.0753 30.2578 25.3819 27.8198 27.8198ZM10.8492 10.8493C9.31087 12.3876 8.26322 14.3477 7.83878 16.4814C7.41434 18.6152 7.63218 20.827 8.46474 22.837C9.29731 24.8469 10.7072 26.5649 12.5161 27.7736C14.3251 28.9823 16.4518 29.6274 18.6274 29.6274C20.803 29.6274 22.9297 28.9823 24.7387 27.7736C26.5476 26.5649 27.9575 24.8469 28.7901 22.837C29.6227 20.827 29.8405 18.6152 29.4161 16.4814C28.9916 14.3477 27.944 12.3876 26.4056 10.8493C24.3427 8.78637 21.5448 7.62744 18.6274 7.62744C15.71 7.62744 12.9121 8.78637 10.8492 10.8493Z",
    fill: "#B4BDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.6058L14.2602 20.8667L16.5211 23L24.9994 15",
    stroke: "#B4BDCA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCheckmarkGrey);
export default __webpack_public_path__ + "static/media/icon_circle_checkmark_grey.43157a860117b76d2b16ee2a50573df9.svg";
export { ForwardRef as ReactComponent };